import { Dispatch } from "redux";
import axios from "../../utils/axios.tsx";
import { searchFieldActions } from "../../store/search/searchField.tsx";
import { loginAsAnonymousUser } from "../../store/auth.tsx";
import { conversationActions } from "../../store/conversation.tsx";

interface AskQuestionParams {
  dispatch: Dispatch;
  isAuthenticated?: boolean;
  searchText: string;
  stopAnimation: () => void;
}

export async function ask({
  dispatch,
  searchText,
  stopAnimation,
}: AskQuestionParams): Promise<void> {
  const url = "/v1/anonymous/faq/ask/";

  try {
    dispatch(searchFieldActions.setAwaitingAskResponse(true));
    dispatch(
      conversationActions.appendExchange({
        prompt: searchText,
        response: null,
      }),
    );

    const response = await axios.post(
      url,
      JSON.stringify({ text: searchText }),
      { withCredentials: true },
    );

    dispatch(loginAsAnonymousUser());

    dispatch(conversationActions.appendExchange(response.data));
  } catch (error) {
    console.error("Error fetching data:", error);
  } finally {
    stopAnimation();
    dispatch(searchFieldActions.setAwaitingAskResponse(false));
  }
}

export default ask;
